var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"max-width":_vm.maxWidth,"nudge-left":_vm.offsetLeft,"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"action-btn text-capitalize -orange-theme -common -list-action",class:{
        '-common': !_vm.deactivationPage,
        '-list-action': !_vm.deactivationPage,
        '-submit': _vm.deactivationPage,
        '-small': _vm.xsOnly,
      },attrs:{"outline":"","disabled":_vm.requestOnProcess,"loading":_vm.requestOnProcess},on:{"click":_vm.onActivate}},on),[_vm._v(" Extend Payment ")])]}}])},[_c('span',[_vm._v(" An additional 10 days extension will be applied to settle your payment. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }